import { render, staticRenderFns } from "./NotesFilters.vue?vue&type=template&id=0ffeaf1e&scoped=true"
import script from "./NotesFilters.vue?vue&type=script&lang=js"
export * from "./NotesFilters.vue?vue&type=script&lang=js"
import style0 from "./NotesFilters.vue?vue&type=style&index=0&id=0ffeaf1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffeaf1e",
  null
  
)

export default component.exports